import { render, staticRenderFns } from "./ContentSection.vue?vue&type=template&id=8a60cce6&scoped=true"
import script from "./ContentSection.vue?vue&type=script&lang=js"
export * from "./ContentSection.vue?vue&type=script&lang=js"
import style0 from "./ContentSection.vue?vue&type=style&index=0&id=8a60cce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a60cce6",
  null
  
)

export default component.exports